module.exports = __webpack_public_path__ + "img/tool-card.a5664fbe.svg";